import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { deleteMachinePart } from '@/apis/machinePart'
import UpdateDetergentForm from '@/components/pages/Detergents/Update/Form'
import UpdateDetergentPageHeader from '@/components/pages/Detergents/Update/PageHeader'
import routes from '@/constants/routes'
import { useTanks } from '@/pages/Tank/Tank.hooks'
import { Detergent } from '@/types'
import { UpdateDetergentRequest } from '@/types/apis/detergents/UpdateDetergentRequest'

import { useGetDetergent, useUpdateDetergents } from './Update.hooks'

const UpdateDetergent = () => {
  const params = useParams<{ id: string }>()

  const detergentId = Number(params.id)

  const navigate = useNavigate()

  const { updateDetergent, loading: updateLoading } = useUpdateDetergents()
  const { getDetergent, loading: getLoading, response: getDetergentResponse } = useGetDetergent()

  const { getAllTanks, tanks } = useTanks()

  const handleDeleteDetergent = async (id: Detergent['id']) => {
    await deleteMachinePart({ id })
  }

  const handleSubmitForm = async (formValues: UpdateDetergentRequest) => {
    await updateDetergent({
      ...formValues,
      id: detergentId,
    })

    navigate(routes.detergents.path)
  }

  useEffect(() => {
    getDetergent({ id: detergentId })
    getAllTanks()
  }, [detergentId, getAllTanks, getDetergent, params.id])

  return (
    <>
      <UpdateDetergentPageHeader />
      <UpdateDetergentForm
        {...{ updateLoading, getLoading, getDetergentResponse, detergentId, tanks }}
        onSubmit={handleSubmitForm}
        onDelete={handleDeleteDetergent}
      />
    </>
  )
}

UpdateDetergent.displayName = 'UpdateDetergent'
export default UpdateDetergent
